module.exports = __webpack_public_path__ + "img/homePageImg05.0a8e37e7.png";